/* ============================================================
   THEME.JS — DURAFINE PRECISION
   Progressive enhancement only: every form posts normally without JS.
   Modules: header · mobile nav · predictive search · cart drawer ·
            product (gallery, variants, qty, buy bar) · recommendations ·
            collection filters · floaters · scroll reveal
   ============================================================ */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function store(fn) { try { return fn(); } catch (e) { return null; } }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Header: condense on scroll ---------- */
  var header = $('[data-header]');
  var cta = $('[data-sticky-cta]');
  var ctaDismissed = store(function () { return sessionStorage.getItem('dfCtaDismissed') === '1'; });
  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-condensed', y > 40);
    if (cta && !ctaDismissed) cta.hidden = y < Math.max(700, document.body.scrollHeight * 0.3 - window.innerHeight);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var ctaClose = $('[data-sticky-cta-close]');
  if (ctaClose) {
    ctaClose.addEventListener('click', function () {
      cta.hidden = true;
      ctaDismissed = true;
      store(function () { sessionStorage.setItem('dfCtaDismissed', '1'); });
    });
  }

  /* ---------- Mobile nav ---------- */
  var burger = $('[data-nav-toggle]');
  var drawerNav = $('[data-mobile-nav]');
  if (burger && drawerNav) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      drawerNav.hidden = open;
      document.body.classList.toggle('nav-open', !open);
    });
  }

  /* ---------- Predictive search ---------- */
  var search = $('[data-search]');
  var searchToggle = $('[data-search-toggle]');
  if (search) {
    var input = $('[data-search-input]', search);
    var results = $('[data-search-results]', search);
    var debounce, controller;

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var open = search.classList.toggle('is-open');
        if (open) input.focus();
      });
    }

    function closeResults() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(products, q) {
      var html = '';
      if (!products.length) {
        html = '<span class="search-empty">' + theme.strings.noResults + '</span>';
      } else {
        products.forEach(function (p, i) {
          var media = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">'
            : '<svg viewBox="0 0 48 48" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2"><circle cx="24" cy="24" r="18"/><circle cx="24" cy="24" r="3"/></svg>';
          html += '<a class="search-hit" role="option" id="sr-' + i + '" href="' + p.url + '">' +
            '<span class="search-hit__media">' + media + '</span>' +
            '<span class="search-hit__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="search-hit__price">' + (p.price_formatted || '') + '</span></a>';
        });
      }
      html += '<a class="search-all" href="' + theme.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">' + theme.strings.viewAll + ' →</a>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { closeResults(); return; }
      debounce = setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            products.forEach(function (p) { p.price_formatted = formatMoney(p.price); });
            render(products, q);
          })
          .catch(function () {});
      }, 180);
    });

    input.addEventListener('keydown', function (e) {
      var hits = $$('.search-hit', results);
      if (!hits.length || results.hidden) return;
      var idx = hits.findIndex(function (h) { return h.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx > -1) hits[idx].removeAttribute('aria-selected');
        idx = e.key === 'ArrowDown' ? (idx + 1) % hits.length : (idx - 1 + hits.length) % hits.length;
        hits[idx].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', hits[idx].id);
      } else if (e.key === 'Enter' && idx > -1) {
        e.preventDefault();
        window.location.href = hits[idx].href;
      } else if (e.key === 'Escape') {
        closeResults();
      }
    });

    document.addEventListener('click', function (e) {
      if (!search.contains(e.target) && e.target !== searchToggle) closeResults();
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Predictive search returns price as a decimal string in shop currency */
  function formatMoney(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    var amount = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = theme.moneyFormat || 'AED {{amount}}';
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, amount);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = $('.drawer__panel', drawer);
      if (panel) panel.focus();
    });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 280);
    if (lastFocus) lastFocus.focus();
  }

  function sectionId() {
    var wrap = drawer && drawer.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  function applyCartSection(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-content]', doc);
    var current = $('[data-cart-drawer-content]', drawer);
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    }
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
      b.classList.remove('is-bumped');
      void b.offsetWidth;
      b.classList.add('is-bumped');
    });
  }

  function refreshDrawer() {
    return fetch(theme.routes.root + '?sections=' + sectionId())
      .then(function (r) { return r.json(); })
      .then(function (data) { applyCartSection(data[sectionId()]); });
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && !document.body.classList.contains('template-cart')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

      var change = e.target.closest('[data-line-change]');
      if (change && drawer.contains(change)) {
        drawer.classList.add('is-busy');
        fetch(theme.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: parseInt(change.getAttribute('data-line-change'), 10),
            quantity: Math.max(0, parseInt(change.getAttribute('data-qty'), 10)),
            sections: sectionId()
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { toast(data.description || theme.strings.error, true); return refreshDrawer(); }
            applyCartSection(data.sections && data.sections[sectionId()]);
          })
          .catch(function () { toast(theme.strings.error, true); })
          .finally(function () { drawer.classList.remove('is-busy'); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* AJAX add-to-cart for every [data-cart-form] */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form || !drawer || !window.fetch || !window.FormData) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();

    var buttons = $$('[data-add-button]').filter(function (b) { return b.form === form || form.contains(b); });
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

    var fd = new FormData(form);
    fd.append('sections', sectionId());
    fd.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { toast(data.description || theme.strings.error, true); return; }
        applyCartSection(data.sections && data.sections[sectionId()]);
        buttons.forEach(function (b) {
          b.classList.add('is-added');
          setTimeout(function () { b.classList.remove('is-added'); }, 1400);
        });
        openDrawer();
      })
      .catch(function () { toast(theme.strings.error, true); })
      .finally(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    /* Gallery thumbs */
    var main = $('[data-gallery-main]', root);
    function showMedia(id) {
      if (!main || !id) return;
      var target = $('[data-media-id="' + id + '"]', main);
      if (!target) return;
      $$('.gallery__slide', main).forEach(function (s) { s.classList.toggle('is-active', s === target); });
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    /* Qty stepper */
    var qty = $('[data-qty-input]', root);
    $$('[data-qty-step]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
        qty.value = next;
      });
    });

    /* Variants */
    var jsonEl = $('[data-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var idInput = $('[data-variant-id]', root);
    var addButtons = $$('[data-add-button]', root);
    var buyBarPrice = $('[data-buy-bar-price]', root);

    function currentOptions() {
      return $$('.option', root).map(function (fs) {
        var checked = $('input[data-option]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    $$('input[data-option]', root).forEach(function (radio) {
      radio.addEventListener('change', function () {
        var opts = currentOptions();
        var fs = radio.closest('.option');
        var label = fs && $('[data-option-value]', fs);
        if (label) label.textContent = radio.value;

        var variant = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });

        var priceWrap = $('[data-price-wrap] .price', root);
        var stock = $('[data-stock]', root);
        var stockText = $('[data-stock-text]', root);
        var sku = $('[data-sku]', root);

        if (!variant) {
          addButtons.forEach(function (b) { b.disabled = true; var s = $('span', b); if (s) s.textContent = theme.strings.unavailable; });
          return;
        }

        idInput.value = variant.id;
        if (priceWrap) {
          var cur = $('.price__current', priceWrap);
          if (cur) cur.textContent = variant.price;
          var cmp = $('.price__compare', priceWrap);
          if (cmp) cmp.textContent = variant.compare || '';
          priceWrap.classList.toggle('price--sale', !!variant.compare);
        }
        if (buyBarPrice) buyBarPrice.textContent = variant.price;
        if (sku) { sku.hidden = !variant.sku; var s = $('span', sku); if (s) s.textContent = variant.sku || ''; }
        if (stock) stock.classList.toggle('stock--out', !variant.available);
        if (stockText) stockText.textContent = variant.available ? stockText.getAttribute('data-in') || stockText.textContent : theme.strings.soldOut;
        addButtons.forEach(function (b) {
          b.disabled = !variant.available;
          var span = $('span', b);
          if (span && !b.hasAttribute('data-short')) span.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        });
        if (variant.media) showMedia(variant.media);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });

    /* Remember the in-stock label so variant switching can restore it */
    var st = $('[data-stock-text]', root);
    if (st && !$('[data-stock]', root).classList.contains('stock--out')) st.setAttribute('data-in', st.textContent);

    /* Mobile buy bar: visible once the main add button leaves the viewport */
    var bar = $('[data-buy-bar]', root);
    var mainAdd = $('[data-main-add]', root);
    if (bar && mainAdd && 'IntersectionObserver' in window && window.matchMedia('(max-width: 989px)').matches) {
      var barButton = $('button', bar);
      if (barButton) barButton.setAttribute('data-short', '');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(mainAdd);
    }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- Collection filters & sort ---------- */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') submitFilters();
    });
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(); });
  }
  function submitFilters() {
    var params = new URLSearchParams(new FormData(filterForm));
    Array.from(params.keys()).forEach(function (k) {
      if (params.get(k) === '') params.delete(k);
    });
    window.location.search = params.toString();
  }
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });
  }
  var filters = $('[data-filters]');
  var filtersOpen = $('[data-filters-open]');
  var filtersClose = $('[data-filters-close]');
  if (filters && filtersOpen) {
    filtersOpen.addEventListener('click', function () { filters.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  }
  if (filters && filtersClose) {
    filtersClose.addEventListener('click', function () { filters.classList.remove('is-open'); document.body.style.overflow = ''; });
  }

  /* ---------- Marquee: duplicate groups until the track overfills ---------- */
  var track = $('[data-marquee-track]');
  if (track && !reduceMotion) {
    var group = $('.marquee-bar__group', track);
    var safety = 0;
    while (group && track.scrollWidth < window.innerWidth * 2.2 && safety < 6) {
      var a = group.cloneNode(true); a.setAttribute('aria-hidden', 'true');
      var b = group.cloneNode(true); b.setAttribute('aria-hidden', 'true');
      track.appendChild(a); track.appendChild(b);
      safety++;
    }
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = $$('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); revealer.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* Theme editor: re-run reveal for sections loaded in the editor */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
  });
})();
